import React from 'react';
import Modal from '../shared/RespModal';
import icon from '../../assets/images/alert.svg';
import Button from '../shared/Button';
import '../../css/shared/DeleteAssignRoleModal.css';
class DeleteAssignRoleModal extends React.Component {
    render() {
        return (
            <Modal hasOpen={this.props.hasOpen}>
                <div>
                    <img src={icon} width="60" height="60" alt="" />
                    {this.props.children}
                    <Button
                        type="button"
                        class="okbtn"
                        onClick={this.props.onClick}
                    >OK</Button>
                </div>
            </Modal>
        );
    }
}
export default DeleteAssignRoleModal;